import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MESSAGE_ALGO_SALIO_MAL, show_popup, TITLE_ERROR } from '../../utility/popup-error';
import { RedirectionService } from '../../services/redirection.service';

import { AuthService } from '@auth/auth.service';

@Component({
  selector: 'app-redirection',
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.css'],
})
export class RedirectionComponent implements OnInit {
  response: any;
  showLoader = true;
  private urlToReturn: any;

  constructor(private redirect: RedirectionService, private router: Router, private authService: AuthService) {}

  ngOnInit() {
    this.showLoader = false;
    this.redirect.currentMessage.subscribe((response) => (this.response = response));

    this.nextFlow();
  }

  nextFlow(): void {
    this.urlToReturn = this.response.response.messages.filter((message) => message.key === 'Redirection');

    if (this.urlToReturn.length > 0) {
      this.router.navigate([this.urlToReturn[0].value]);
    } else {
      show_popup(TITLE_ERROR, MESSAGE_ALGO_SALIO_MAL).then(() => {
        if (this.authService.isAuthenticated()) {
          this.authService.logout();
        }
      });
    }
  }
}
